import { render, staticRenderFns } from "./waitingCheck.vue?vue&type=template&id=088ba7ba&scoped=true&"
import script from "./waitingCheck.vue?vue&type=script&lang=js&"
export * from "./waitingCheck.vue?vue&type=script&lang=js&"
import style0 from "./waitingCheck.vue?vue&type=style&index=0&id=088ba7ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088ba7ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VContainer,VFlex,VImg,VLayout})
